import type { FaireProductEntity } from "../../entity_types/product";

export const p_natp5ubn35: FaireProductEntity = {
  token: "p_natp5ubn35",
  type: "product",
  name: "Organic Mango & Coconut Fruit Bites, 22 pound (10kg) bulk case",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d4fe1885d1e7ba7c5abb5cb379a6e1a714923d78ebd900df33afa4eeecaba27c.png",
  galleryImageUrls: [],
  priceDollars: 259.11,
  description:
    "Mango + Coconut chewy fruit bites are just that – mango and coconut. They have no added sugar making them a healthy, delicious snack for kids and adults alike. With 1.94oz per bag, they fit well in a lunchbox or hiking pack. They're 100% plant based making them the perfect snack for vegans and vegetarians. They're organic, non-GMO, and direct trade certified. Each bite supports small-scale farmers in Africa.",
  tags: [],
  msrpDollars: 512.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:20.380Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
